
import { refreshAccessToken, logoutAndRedirect } from './authUtils';

type RequestOptions = {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  token?: any;
  queryParams?: Record<string, string | number | boolean>;
  body?: any;
  headers?: Record<string, string>;
  retryOn401?: boolean;
};

const BASE_URL = import.meta.env.VITE_API_URL;

export const apiClient = (
  endpoint: string,
  options: RequestOptions = {}
): Promise<any> => {
  const {
    method = 'GET',
    token ,
    queryParams,
    body,
    headers = {},
    retryOn401 = true,
  } = options;

  const queryString = queryParams
    ? '?' + new URLSearchParams(queryParams as any).toString()
    : '';

  const url = `${BASE_URL}${endpoint}${queryString}`;

  return fetch(url, {
    method,
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    },
    ...(body && { body: JSON.stringify(body) }),
  })
    .then(async (response) => {
      // debugger
      if ((response.status === 401 || response.status === 500) && retryOn401) {
        const newToken = await refreshAccessToken();
        if (newToken) {
          return apiClient(endpoint, {
            ...options,
            token: localStorage.getItem('token'),
            retryOn401: false,
          });
        } else {
          logoutAndRedirect();
          return Promise.reject(new Error('Unauthorized'));
        }
      }

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        const err = new Error(error.message || 'API Error');
        err.status = response.status;
        // throw new Error(error.message || 'API Error');
        throw err;
      }

      return response
    })
    .catch((err) => {
      console.error('API Error:', err);
      throw err;
    });
};



// import { refreshAccessToken, logoutAndRedirect } from './authUtils';

// type RequestOptions = {
//   method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
//   token?: string;
//   queryParams?: Record<string, string | number | boolean>;
//   body?: any;
//   headers?: Record<string, string>;
//   retryOn401?: boolean;
// };

// const BASE_URL = import.meta.env.VITE_API_URL;

// export const apiClient = async (
//   endpoint: string,
//   options: RequestOptions = {}
// ): Promise<any> => {
//   const {
//     method = 'GET',
//     token,
//     queryParams,
//     body,
//     headers = {},
//     retryOn401 = true,
//   } = options;

//   const queryString = queryParams
//     ? '?' + new URLSearchParams(queryParams as any).toString()
//     : '';

//   const url = `${BASE_URL}${endpoint}${queryString}`;
// debugger
//   try {
//     const response = await fetch(url, {
//       method,
//       cache: 'no-store',
//       headers: {
//         'Content-Type': 'application/json',
//         ...(token && { Authorization: `Bearer ${token}` }),
//         ...headers,
//       },
//       ...(body && { body: JSON.stringify(body) }),
//     });
    

//     if ((response.status === 401 || response.status === 500)  && retryOn401) {
//       const newToken = await refreshAccessToken(); // try refresh

//       if (newToken) {
//         // retry once with refreshed token
//         return apiClient(endpoint, {
//           ...options,
//           token: newToken,
//           retryOn401: false, // don't retry again
//         });
//       } else {
//         logoutAndRedirect(); // redirect to signin
//         return;
//       }
//     }

//     if (!response.ok) {
//       const error = await response.json().catch(() => ({}));
//       throw new Error(error.message || 'API Error');
//     }

//     return response;
//   } catch (err) {
//     console.error('API Error:', err);
//     throw err;
//   }
// };
